<div class="content">
    <div class="content-header">
        <h1>Configuraciones de presorteo</h1>
        <p>Aquí encontrarás la lista de configuraciones de presorteo</p>
    </div>
    <div class="content-body">
        <div class="card">
            <div class="btnHolder">
                <button pButton pRipple type="button" label="Crear configuración" class="p-button-raised p-mb-3" (click)="goToCreate()"></button>
            </div>
            <app-config-presorteo-list *ngIf="configPresorteos != null" [configPresorteos]="configPresorteos"></app-config-presorteo-list>
        </div>
    </div>
</div>
